import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useEffect, useState } from "react";
import { cmmsTheme } from "@setup/theme/cmms-theme";

// MuiGrid-item
export const SearchFilter = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";
	
	const [localSearchText, setLocalSearchText] = useState(search);
	const [debouncedSearchText] = useDebounce(localSearchText, 400);

	useEffect(() => {
		setLocalSearchText(search);
	}, [search]);

	useEffect(() => {
		if (debouncedSearchText !== search) {
			searchParams.set("search", debouncedSearchText);
			setSearchParams(searchParams, { replace: true });
		}
	}, [debouncedSearchText, searchParams, setSearchParams, search]);

	const handleFilter = (e: any) => {
		setLocalSearchText(e.target.value);
	};

	return (
		<Box position="relative">
			<TextField
				label="Search"
				variant="outlined"
				margin="dense"
				value={localSearchText}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
				InputLabelProps={{
					style: {
						transform: "translate(14px, -6px) scale(0.75)",
						backgroundColor: cmmsTheme.colors.surfaceWhite,
						transition: "none !important",
						left: -3.5,
						padding: "0 5px"
					}
				}}
				InputProps={{
					style: {
						color: "black",
						paddingRight: 45,
						borderTopLeftRadius: 3,
						borderTopRightRadius: 3
					}
				}} />
			<>
				<i
					className="fa fa-search"
					style={{
						position: "absolute",
						right: 17,
						top: 20,
						cursor: "pointer",
					}}></i>
			</>
		</Box>
	);
};
